// @flow

import * as React from "react"
import {toDinero} from "../../util"
import {withTranslation} from "react-i18next"
import {debounce} from "lodash"
import PriceInput from "../price-input"
import type {Invoice} from "../../types"

type Props = {
  +isInclVAT: boolean,
  +invoice: ?Invoice,
  +t: any,
  +onAmountDiscountUpdate: (string, string) => void,
  +onNoteChange: (string) => void,
}

type State = {
  +note: string,
}

class InvoiceFooter extends React.Component<Props, State> {
  handleNoteChange: (SyntheticInputEvent<HTMLInputElement>) => void
  persistNote: (string) => void

  constructor(props: Props) {
    super(props)
    this.state = {
      note: props.invoice ? props.invoice.note || "" : "",
    }
    this.handleNoteChange = this.handleNoteChange.bind(this)
    this.persistNote = debounce(this.persistNote.bind(this), 200, {
      leading: false,
      trailing: true,
    })
  }

  handleNoteChange(e: SyntheticInputEvent<HTMLInputElement>) {
    const note = e.currentTarget.value
    this.setState({note}, () => {
      this.persistNote(note)
    })
  }

  persistNote(note: string) {
    this.props.onNoteChange(note)
  }

  renderDiscountComp() {
    const {invoice} = this.props
    if (!invoice) return null
    const {amountDiscount} = invoice
    return (
      <div className="d-flex align-items-center justify-content-end">
        <span className="d-inline-block mr-2">
          <strong>-</strong> €
        </span>
        <PriceInput
          name="amountDiscount"
          className="form-control text-right px-2"
          style={{height: 26, width: "23%"}}
          id={`amountDiscount`}
          value={amountDiscount}
          onChange={this.props.onAmountDiscountUpdate}
        />
      </div>
    )
  }

  renderInclVAT() {
    const {t, invoice} = this.props
    if (!invoice) return null
    const {isEditable, totals, amountDiscount} = invoice
    const desposit =
      invoice.amountDeposit && invoice.amountDeposit.length > 1 ? (
        <div className="row">
          <div className="col">{t("invoice.deposit")}</div>
          <div className="col">
            {toDinero(invoice.amountDeposit).multiply(-1).toFormat("$0,0.00")}
          </div>
        </div>
      ) : null
    const gift =
      invoice.amountGift && invoice.amountGift.length > 1 ? (
        <div className="row">
          <div className="col">{t("invoice.gift")}</div>
          <div className="col">
            {toDinero(invoice.amountGift).multiply(-1).toFormat("$0,0.00")}
          </div>
        </div>
      ) : null
    return (
      <>
        <div className="row">
          <div className="col">{t("invoice.amount_discount_incl")}</div>
          <div className="col">
            {isEditable
              ? this.renderDiscountComp()
              : toDinero(amountDiscount).multiply(-1).toFormat("$0,0.00")}
          </div>
        </div>
        <div className="row">
          <div className="col">{t("invoice.total_items_incl_vat")}</div>
          <div className="col">
            {toDinero(totals.totalItemsInclVat).toFormat("$0,0.00")}
          </div>
        </div>
        {desposit}
        {gift}
        <div className="row">
          <div className="col">{t("invoice.total_incl_vat")}</div>
          <div className="col">
            {toDinero(totals.totalInclVat).toFormat("$0,0.00")}
          </div>
        </div>
      </>
    )
  }

  renderExclVAT() {
    const {t, invoice} = this.props
    if (!invoice) return null
    const {isEditable, totals, amountDiscount} = invoice
    return (
      <>
        <div className="row">
          <div className="col">{t("invoice.amount_discount_excl")}</div>
          <div className="col">
            {isEditable
              ? this.renderDiscountComp()
              : toDinero(amountDiscount).multiply(-1).toFormat("$0,0.00")}
          </div>
        </div>
        <div className="row">
          <div className="col">{t("invoice.total_items_excl_vat")}</div>
          <div className="col">
            {toDinero(totals.totalItemsExclVat).toFormat("$0,0.00")}
          </div>
        </div>
      </>
    )
  }

  render() {
    const {t, invoice, isInclVAT} = this.props
    if (!invoice) return null
    const {isEditable} = invoice
    const rows = isInclVAT ? this.renderInclVAT() : this.renderExclVAT()
    return (
      <footer className="invoice-sheet-footer mb-4">
        <div className="invoice-totals">{rows}</div>
        <div className="row">
          <div className="col">
            <div className="note">
              <label htmlFor="note">{t("invoice.note")}</label>
              <textarea
                className="form-control"
                name="note"
                id="note"
                rows="3"
                disabled={!isEditable}
                value={this.state.note}
                onChange={this.handleNoteChange}
              />
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default withTranslation()(InvoiceFooter)
